import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {isPresent} from '../utilities/utils';

export function matchBy(field: string): ValidatorFn {

  if (!field) {
    return Validators.nullValidator;
  }

  return (control: AbstractControl): ValidationErrors | null => {
    if (!isPresent(control.value) && !control.parent) {
      return null;  // don't validate empty values to allow optional controls
    }

    const matchControl = control.parent.get(field);
    const value: string = control.value;
    if (matchControl && isPresent(matchControl.value)) {
      if (value !== matchControl.value) {
        return {
          mismatchedFields: true
        };
      }
    }

    return null;
  };
}
